import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";

import {FETCHING_CUSTOM_FIELDS_REQUEST, FETCHING_CUSTOM_FIELDS_FAILED, FETCHING_CUSTOM_FIELDS_SUCCEEDED} from './actionTypes';
import { FetchCustomFieldsErrorResponse, FetchCustomFieldsResponse } from "../../types/customFields.js";
  
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const CUSTOM_FIELDS_URL = `${apiUrl}/api/2.0/custom_fields`;

export const fetchCustomFields = createAction<any>(FETCHING_CUSTOM_FIELDS_REQUEST);

const fetchingCustomFieldsSucceeded = createAction<FetchCustomFieldsResponse>(FETCHING_CUSTOM_FIELDS_SUCCEEDED);

const fetchingCustomFieldsFailed = createAction<FetchCustomFieldsErrorResponse>(FETCHING_CUSTOM_FIELDS_FAILED);

const fetchCustomFieldsSaga = function* (): any  {
  const fetchCustomFieldsAPI = () => {
    return axios({
      method: "GET",
      url: `${CUSTOM_FIELDS_URL}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCustomFieldsAPI);
    yield put(fetchingCustomFieldsSucceeded(response));
  } catch (error) {
    yield put(fetchingCustomFieldsFailed({error: error}));
  }
};

export default function* customFieldsSaga() {
    yield takeEvery(FETCHING_CUSTOM_FIELDS_REQUEST, fetchCustomFieldsSaga);
}
